module.exports = __webpack_public_path__ + "img/logo_header.9b675561.svg";